module.exports = __webpack_public_path__ + "static/img/TokenPocket_Logo__ traverse.11c94dec.png";